module.exports = __webpack_public_path__ + "static/img/5842_phase_function_Paper_Points.3038197.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5842_phase_function_Paper_Points.png
// module id = i6uI
// module chunks = 0